import Dashlet from "./Dashlet";
import settingsReducer from "./reducers";
import todos from "./todos";
const extTodos = [];
function init(context) {
    context.registerReducer(["settings", "firststeps"], settingsReducer);
    context.registerToDo = (id, type, props, icon, text, action, condition, value, priority) => {
        extTodos.push({
            id,
            icon,
            type,
            props,
            condition,
            text,
            value,
            action,
            priority,
        });
    };
    context.registerDashlet("ToDo List", 3, 2, 0, Dashlet, (state) => {
        const allTodos = [].concat(todos(context.api), extTodos);
        // Defensive check: firststeps might not be initialized during hydration
        const steps = state.settings?.firststeps?.steps ?? {};
        const visibleSteps = allTodos.filter((item) => {
            if (steps[item.id]) {
                return false;
            }
            if (item.condition) {
                const props = item.props ? item.props(state) : {};
                return item.condition(props);
            }
            else {
                return true;
            }
        });
        return visibleSteps.length > 0;
    }, () => ({
        todos: [].concat(todos(context.api), extTodos),
    }), undefined);
    return true;
}
export default init;
